import { registerCreateServiceResponseCallback as registerOwsCreateServiceResponseCallback } from 'owa-service/lib/fetchWithRetry';
import { registerCreateServiceResponseCallback as registerOwsPrimeCreateServiceResponseCallback } from 'owa-ows-gateway';
import { lazyCaptureServiceActionOptics } from './LazyAnalytics';
import RequestOptions from 'owa-service/lib/RequestOptions';
import isPerformanceTimingSupported from './utils/isPerformanceTimingSupported';
import IPerformance from './types/Performance';

declare global {
    /*tslint:disable:all*/
    interface Performance extends IPerformance {}
    /*tslint:enable:all*/
}

const defaultResourceTimingBufferSize: number = 500;
export default function registerServiceActionAnalytics() {
    registerOwsCreateServiceResponseCallback(trackServiceRequest);
    registerOwsPrimeCreateServiceResponseCallback(trackServiceRequest);
    initializeResourceTimingBuffer();
}

function initializeResourceTimingBuffer() {
    if (isPerformanceTimingSupported()) {
        if (window.performance.setResourceTimingBufferSize) {
            window.performance.setResourceTimingBufferSize(defaultResourceTimingBufferSize);
        } else if (window.performance.webkitSetResourceTimingBufferSize) {
            window.performance.webkitSetResourceTimingBufferSize(defaultResourceTimingBufferSize);
        }
    }
}

function trackServiceRequest(
    responsePromise: Promise<Response>,
    actionName: string,
    url: string,
    attemptCount: number,
    options: RequestOptions
) {
    lazyCaptureServiceActionOptics.importAndExecute(
        responsePromise,
        actionName,
        url,
        attemptCount,
        options
    );
}
